import { GeneralService } from "../../shared/services/general.service";

export class Constants {
  public static readonly COGNITO_EXCETPION = {
    USER_NOT_FOUND: "UserNotFoundException",
    NOT_AUTHORIZED: "NotAuthorizedException",
    LIMIT_EXCEEDED: "LimitExceededException",
    INVALID_PARAMETER: "InvalidParameterException",
    CODE_MISMATCH: "CodeMismatchException",
    USER_NOT_CONFIRMED: "UserNotConfirmedException",
  };

  public static readonly MSG = {
    // error messages
    GENERAL_ERROR: "An error occurred, please try again.",
    LOGIN_WRONG_CREDENTIALS:
      "Authentication failed. Please check your password and try again.",
    USER_NOT_FOUND:
      "Authentication failed. Please check your password and try again.",
    LIMIT_EXCEEDED: "Attempt limit exceeded, please try after some time.",
    CANNOT_RESET_PWD:
      "Cannot reset password for the user as there is no registered/verified email or phone number.",
    INVALID_VERIFICATION_CODE:
      "Invalid verification code provided, please try again.",
    PWDS_DONT_MATCH: "Passwords do not match.",
    PWD_RESTRICTIONS: `Password must be at least 10 characters, one lowercase letter,
        one uppercase letter, one digit and one special character.`,
    USER_NOT_CONFIRMED: `Please select a new password.`,
    // success messages
    PWD_CHANGED: "Password changed with success.",
  };

  public static readonly REGEX = {
    PASSWORD_REGEX: /^(?=.{10,})(?=.*[a-z])(?=.*[A-Z])(?=.*[^\w\d=+€]).*$/,
    MAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
  };

  // legacy services messages

  public static readonly MIN_USERNAME_LENGTH =
    "Username must have a minimum of 8 characters.";
  // success messages
  public static readonly FORGOT_EMAIL_SENT = "Email sent.";
  public static readonly VALID_EMAIL = "Please enter a valid email.";
}



// WEBPACK FOOTER //
// ./src/app/core/services/constants.ts